import React, { useCallback } from 'react';
import { ProviderField } from '../../models/provider';
import { SubmitProviderInputsPayload } from '../screens/SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import { PageView, UserInteractionEvent } from '../../models/analytics';
import { usePageViewEvents } from '../../core/Analytics/usePageViewEvents';
import { AppCodeTemplateView, AppCodeTemplateViewProps } from './AppCodeTemplateView';

export type AppCodeTemplateScreenProps = {
  fields: ProviderField[];
  onSubmit: (values: SubmitProviderInputsPayload) => void;
  AppCodeTemplate?: React.ComponentType<AppCodeTemplateViewProps>;
};

export const AppCodeTemplateScreen: React.FC<AppCodeTemplateScreenProps> = ({
  fields,
  onSubmit,
  AppCodeTemplate = AppCodeTemplateView,
}) => {
  const { sendViewInteractionEvent, sendViewInteractionEventOnce } = usePageViewEvents({
    pageView: PageView.APP_CODE_TEMPLATE_SCREEN,
  });

  const handleSubmitWithAnalytics = (values: SubmitProviderInputsPayload) => {
    sendViewInteractionEvent({ interaction: UserInteractionEvent.SUBMIT_SUPPLEMENTAL_INFORMATION });
    onSubmit(values);
  };

  const handleToggle = useCallback(
    (name: string) => {
      sendViewInteractionEventOnce({
        interaction: UserInteractionEvent.TOGGLE_ACCORDION,
        label: name,
      });
    },
    [sendViewInteractionEventOnce]
  );

  return (
    <AppCodeTemplate fields={fields} onSubmit={handleSubmitWithAnalytics} onToggle={handleToggle} />
  );
};
